import { Injectable, Injector } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import {AbstractRepositoryV2} from '../../../../../core/service/v2/abstractRepositoryV2';
import {InsolesModelModel} from "../../../api/entity/insolesModel.model";

@Injectable()
export class InsolesModelRepository extends AbstractRepositoryV2<InsolesModelModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('InsolesModel', serviceElementsFactory, injector);
    }
}
